import Vue from 'vue'
import Vuex from 'vuex'
import user from './module/user/index.js'
import app from './module/app'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    user
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js